module.exports = __webpack_public_path__ + "img/_video.fac21339.png";